export const iconFontAwesomeTextformattingTableList = (
	<i className="fa-solid fa-table-list"></i>
);
